import React, { useState } from "react";
import Logisticsorders from "./Logisticsorders";
import Logisticsorderdetails from "./Logisticsorderdetails";
import LogisticesOnline from "./LogisticesOnline";
import LogisticsLiveOrders from "./LogisticsLiveOrders";

const TabsLayout = () => {
  const [activeTab, setActiveTab] = useState("Online");

  const DummySection = ({ title }) => (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );

  const renderComponent = () => {
    switch (activeTab) {
      case "Online":
        return <LogisticesOnline />;
      case "Status":
        return <Logisticsorders />;
      case "Reports":
        return <Logisticsorderdetails />;
          case "Live Rides":
        return <LogisticsLiveOrders />;
      //   case "Summery":
      //     return <Foodsubscribedclients title="Summery" />;

      default:
        return <LogisticesOnline />;
    }
  };

  const tabs = [
    "Online",
    "Status",
    "Reports",
    "Live Rides",


  ];

  return (
    <div className="tabs-wrapper">
      {/* TOP ONE-ROW TABS (ALL SCREENS) */}
      <div className="tabs-row">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={`row-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <div className="tabs-content">
        {renderComponent()}
      </div>
    </div>
  );
};

export default TabsLayout;

